import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { gEnums } from 'global/enums/globalEnums'
import { setStyleAndClass } from 'global/styles/formatting'
import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { SwiperMenu } from './SwiperMenu'
import { Swiper } from 'swiper/react'
import { currentHelpers } from 'global/redirection/current'
import { useCurrentLocation } from 'global/cnr/contexts/useHelpers/useCurrentLocation'
import { useRenders } from 'global/cnr/contexts/useHelpers/useRenders'

export const SwiperAnyContext = createContext();

export const Swiper_Any = ({
  swKey,
  menuItems,
  extraButtons,
  groupDataProps,
  swipeContentType,
  swiperMenuType,
  isChild,
  applyFade = false,
  slides,
  showButtons,
}) => {

  useRenders('Swiper_Any', true, true)

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, currentSettings_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {})

  const tabStyles = {
    tabsSnC: setStyleAndClass(aps_global, gEnums.projectStyles.tabs),
  }

  const { returnedFromDeeperRoute } = useCurrentLocation({ pathViews })

  const swiperRef = useRef(null)

  const _swiperKey_last = currentHelpers.storageItem_get(`swiperKey_${swKey}`)
  const lastIndex = _swiperKey_last || 0
  const [activeIndex, setActiveIndex] = useState(lastIndex || 0)

  // Swiper change → update activeIndex
  const handleSwiperChange = (swiper) => setActiveIndex(swiper.activeIndex)

  // Menu click → directly move swiper
  const handleMenuSelect = (index) => {
    currentHelpers.storageItem_set(`swiperKey_${swKey}`, index)
    swiperRef.current?.slideTo(index)
  }

  useEffect(() => {
    handleMenuSelect(lastIndex)
  }, [lastIndex]);

  return (
    <SwiperAnyContext.Provider value={{ swiperAny_handlers: { handleMenuSelect } }}>
      <div className="swiper-with-tabs tabz">
        {/* Menu */}
        {showButtons && <div className="swipe-menu-container tabs tabz" style={tabStyles.tabsSnC.style}>
          <SwiperMenu
            swipeContentType={swipeContentType}
            menuItems={menuItems}
            extraButtons={extraButtons}
            groupDataProps={groupDataProps}
            swiperMenuType={swiperMenuType}
            activeIndex={activeIndex}
            handleIndexChange={handleMenuSelect}
          />
        </div>}
        {/* Swiper content */}

        {/* // modules={applyFade ? [EffectFade] : []}
          // effect={applyFade ? 'fade' : 'slide'}
          // fadeEffect={{ crossFade: true }} */}
        <div className="swiper-content-container tabz">
          <Swiper
            key={swKey}
            effect="slide"
            speed={100}
            slidesPerView={1}
            spaceBetween={20}
            threshold={10}
            resistance
            nested={isChild}
            touchMoveStopPropagation={isChild ? false : undefined}
            touchStartPreventDefault={isChild ? false : undefined}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={handleSwiperChange}
          >
            {slides}
          </Swiper>
        </div>
      </div>
    </SwiperAnyContext.Provider>
  )
}
